import { useState } from 'react';
import axios from 'axios';

export const useGetExpertEmployees = () => {
  const [expertEmployees, setExpertEmployees] = useState([]);
  const [loadingExperts, setLoadingExperts] = useState(false);

  const clearExperts = () => {
    setExpertEmployees([]);
  };

  const getExperts = async (skillId: string) => {
    setLoadingExperts(true);
    try {
      const response = await axios.get(
        `api/employee-skills/experts/${skillId}`
      );
      setExpertEmployees(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingExperts(false);
    }
  };

  return { expertEmployees, getExperts, clearExperts, loadingExperts };
};
